import { Container, Paper, Typography, Box, Button } from "@mui/material"
import T from "../hooks/Language/T"
import { useApiService } from "../hooks/Api/useApiService"
import useError from "../hooks/Error/useError"

export default function CookiesDisclaimer() {
  const appName = "Sharie"
  const { postData } = useApiService()
  const { Error: ErrorAlert, success, error } = useError()

  const onAccept = () => {
    postData("users/acceptcookies", { user_name: localStorage.getItem("user") }).then((data) => {
      if (data.message === "Successful") success("Cookies accepted successfully!")
      else error("Failed to accept cookies. Please try again later.")
    })
  }

  return (
    <T>
      <Container maxWidth='md' sx={{ py: { xs: 3, md: 6 } }}>
        <Paper
          elevation={3}
          sx={{ p: { xs: 3, md: 5 }, borderRadius: 4, bgcolor: "rgba(255,255,255,0.9)" }}
        >
          <Box sx={{ direction: "rtl", textAlign: "right" }}>
            <Typography variant='h4' sx={{ fontWeight: 800, color: "primary.main", mb: 2 }}>
              שימוש בעוגיות – {appName}
            </Typography>

            <Typography variant='body1' paragraph>
              אנו משתמשים בעוגיות (Cookies) כדי לשפר את חוויית המשתמש, לשמור על ההעדפות שלכם,
              ולהבטיח שימוש חלק ונוח בשירות שלנו. עוגיות אלו מאפשרות גם ניתוח נתוני שימוש לשיפור
              הפלטפורמה.
            </Typography>

            <Typography variant='body1' paragraph>
              על ידי לחיצה על כפתור "קיבלתי" אתם מסכימים לשימוש בעוגיות בהתאם למדיניות זו. תוכלו
              לשנות את הגדרות העוגיות בדפדפן בכל עת.
            </Typography>
          </Box>
          <Box sx={{ display: "flex", justifyContent: "center", mt: 3 }}>
            <Button variant='contained' color='primary' onClick={onAccept}>
              קיבלתי
            </Button>
          </Box>
        </Paper>

        <ErrorAlert />
      </Container>
    </T>
  )
}
